// extracted by mini-css-extract-plugin
export default {"wrapper":"News_wrapper__h0whV","container":"News_container__PRs6B","mt":"News_mt__RK5sq","flex":"News_flex__IKkFL","error":"News_error__-fEk7"};